import { displayExternalReference } from './externalReferences';

// Stored header paths escape customer backslashes and greater-than signs.
// The separator between hierarchy levels remains " > ".
export function joinHeaderPath(labels) {
  return labels.map((label) => String(label).replace(/\\/g, '\\\\').replace(/>/g, '\\>')).join(' > ');
}

export function splitHeaderPath(path) {
  const labels = [];
  let label = '';
  let position = 0;
  while (position < path.length) {
    if (path.startsWith(' > ', position)) {
      labels.push(label);
      label = '';
      position += 3;
    } else if (path[position] === '\\') {
      if (position + 1 === path.length || !['\\', '>'].includes(path[position + 1])) {
        throw new Error(`Invalid escape in header path: ${path}`);
      }
      label += path[position + 1];
      position += 2;
    } else if (path[position] === '>') {
      throw new Error(`Unescaped greater-than sign in header path: ${path}`);
    } else {
      label += path[position];
      position += 1;
    }
  }
  labels.push(label);
  return labels;
}

export function displayMappingValue(value) {
  // Operators remain between backticks. External references have their own
  // escaping, independent of the header-path grammar.
  return String(value).split('`').map((part) => {
    if (part.trim().startsWith('External >> ')) return displayExternalReference(part.trim());
    return splitHeaderPath(part).join(' > ');
  }).join('`');
}
